import { useState } from "react";
import classnames from "classnames";
import Link from "next/link";

import Button from "@/components/Button";
import Typography from "@/components/Typography";
import { routePath } from "@/helpers/routePath";
import RedoOnboardingModal from "@/components/Modals/RedoOnboardingModal";

import styles from "./EmptyState.module.scss";
import { EmptyStateInterface, SubheadingVariant } from "./EmptyState.interface";
import Image from "next/image";
import { getImgixURL } from "@/helpers/getImgixURL";

const EmptyState: React.FC<EmptyStateInterface> = ({
  className,
  heading = "Nie znaleźliśmy żadnego pasującego wyniku.",
  subheading = "Spróbuj zmienić wpisaną frazę.",
  withIcon,
  withButton,
  variant,
}) => {
  const [isOnboardingModalOpen, setOnboardingModalOpen] =
    useState<boolean>(false);

  const toggleOnboardingModal = () => {
    setOnboardingModalOpen((prevState) => !prevState);
  };

  const getSubheading = () => {
    switch (variant) {
      case SubheadingVariant.FollowedPodcasts:
        return (
          <>
            Przejdź do zakładki
            <Link href={routePath.PODCASTS.href}>
              <a className={styles.link}> Wszystkie</a>
            </Link>
            , lub sprawdź popularne i dodaj je do obserwowanych.
          </>
        );
      case SubheadingVariant.PersonalFeed:
        return (
          <>
            Przejdź na stronę
            <Link href={routePath.ACCOUNT_FOLLOWED.href}>
              <a className={styles.link}> Obserwowane </a>
            </Link>
            i dodaj interesujące cię treści, lub przejdź jeszcze raz przez
            personalizację feed’u.
          </>
        );
      default:
        return subheading;
    }
  };
  return (
    <div className={classnames(styles.container, className)}>
      {withIcon && (
        <Image
          src={getImgixURL(
            "https://cdn.newonce.me/uploads/images/46403/Hobbies_Glasses.png"
          )}
          layout="fixed"
          width={160}
          height={160}
          alt="empty state"
        />
      )}
      <Typography variant="h4" component="h4">
        {heading}
      </Typography>
      <Typography variant="large" component="p" className={styles.subheading}>
        {getSubheading()}
      </Typography>

      {withButton && (
        <>
          <Button
            variant="secondaryStroke"
            className={styles.button}
            onClick={toggleOnboardingModal}
          >
            Personalizuj feed
          </Button>
          <RedoOnboardingModal
            onClose={toggleOnboardingModal}
            isOpen={isOnboardingModalOpen}
          />
        </>
      )}
    </div>
  );
};

export default EmptyState;
